/**
 * Configuração de Companhias Aéreas
 * 
 * Responsabilidade: Centralizar dados estáticos de companhias aéreas
 */

export const AIRLINES = {
  // === BRASIL ===
  'LATAM': {
    name: 'LATAM Airlines',
    code: 'LA',
    logo: 'https://i.pinimg.com/1200x/0d/04/bb/0d04bb1980de2098c247543a2cfeb152.jpg'
  },
  'LA': {
    name: 'LATAM Airlines',
    code: 'LA',
    logo: 'https://i.pinimg.com/1200x/0d/04/bb/0d04bb1980de2098c247543a2cfeb152.jpg'
  },
  'GOL': {
    name: 'GOL Linhas Aéreas',
    code: 'G3',
    logo: 'https://i.pinimg.com/736x/88/c0/84/88c084735fd161cacc57768aa344e076.jpg'
  },
  'G3': {
    name: 'GOL Linhas Aéreas',
    code: 'G3',
    logo: 'https://i.pinimg.com/736x/88/c0/84/88c084735fd161cacc57768aa344e076.jpg'
  },
  'AZUL': {
    name: 'Azul Linhas Aéreas',
    code: 'AD',
    logo: 'https://i.pinimg.com/1200x/42/f3/87/42f3879a2f911bac158f6cd237cad9a4.jpg'
  },
  'AD': {
    name: 'Azul Linhas Aéreas',
    code: 'AD',
    logo: 'https://i.pinimg.com/1200x/42/f3/87/42f3879a2f911bac158f6cd237cad9a4.jpg'
  },
  'VOEPASS': {
    name: 'VOEPASS Linhas Aéreas',
    code: '2Z',
    logo: 'https://www.voepass.com.br/wp-content/themes/flavor-developer/assets/images/logo-voepass.png'
  },
  '2Z': {
    name: 'VOEPASS Linhas Aéreas',
    code: '2Z',
    logo: 'https://www.voepass.com.br/wp-content/themes/flavor-developer/assets/images/logo-voepass.png'
  },

  // === EUROPA ===
  'AIR EUROPA': {
    name: 'Air Europa',
    code: 'UX',
    logo: 'https://i.pinimg.com/1200x/3b/98/35/3b9835cf79911d0e7a2d1d5677d11fe1.jpg'
  },
  'UX': {
    name: 'Air Europa',
    code: 'UX',
    logo: 'https://i.pinimg.com/1200x/3b/98/35/3b9835cf79911d0e7a2d1d5677d11fe1.jpg'
  },
  'TAP': {
    name: 'TAP Air Portugal',
    code: 'TP',
    logo: 'https://i.pinimg.com/736x/11/a7/b2/11a7b288d906b15cdb24e3c2004e8bc2.jpg'
  },
  'TP': {
    name: 'TAP Air Portugal',
    code: 'TP',
    logo: 'https://i.pinimg.com/736x/11/a7/b2/11a7b288d906b15cdb24e3c2004e8bc2.jpg'
  },
  'IBERIA': {
    name: 'Iberia',
    code: 'IB',
    logo: 'https://logowik.com/content/uploads/images/iberia3356.logowik.com.webp'
  },
  'IB': {
    name: 'Iberia',
    code: 'IB',
    logo: 'https://logowik.com/content/uploads/images/iberia3356.logowik.com.webp'
  },
  'AIR FRANCE': {
    name: 'Air France',
    code: 'AF',
    logo: 'https://logowik.com/content/uploads/images/389_air_france.jpg'
  },
  'AF': {
    name: 'Air France',
    code: 'AF',
    logo: 'https://logowik.com/content/uploads/images/389_air_france.jpg'
  },
  'KLM': {
    name: 'KLM Royal Dutch Airlines',
    code: 'KL',
    logo: 'https://logowik.com/content/uploads/images/klm8385.logowik.com.webp'
  },
  'KL': {
    name: 'KLM Royal Dutch Airlines',
    code: 'KL',
    logo: 'https://logowik.com/content/uploads/images/klm8385.logowik.com.webp'
  },
  'LUFTHANSA': {
    name: 'Lufthansa',
    code: 'LH',
    logo: 'https://logowik.com/content/uploads/images/lufthansa9228.logowik.com.webp'
  },
  'LH': {
    name: 'Lufthansa',
    code: 'LH',
    logo: 'https://logowik.com/content/uploads/images/lufthansa9228.logowik.com.webp'
  },
  'BRITISH AIRWAYS': {
    name: 'British Airways',
    code: 'BA',
    logo: 'https://1000logos.net/wp-content/uploads/2016/10/British-Airways-Logo.png'
  },
  'BA': {
    name: 'British Airways',
    code: 'BA',
    logo: 'https://1000logos.net/wp-content/uploads/2016/10/British-Airways-Logo.png'
  },
  'SWISS': {
    name: 'Swiss International Air Lines',
    code: 'LX',
    logo: 'https://logowik.com/content/uploads/images/822_swissair.jpg'
  },
  'SWISSAIR': {
    name: 'Swiss International Air Lines',
    code: 'LX',
    logo: 'https://logowik.com/content/uploads/images/822_swissair.jpg'
  },
  'LX': {
    name: 'Swiss International Air Lines',
    code: 'LX',
    logo: 'https://logowik.com/content/uploads/images/822_swissair.jpg'
  },
  'TURKISH': {
    name: 'Turkish Airlines',
    code: 'TK',
    logo: 'https://images.seeklogo.com/logo-png/36/1/turkish-airlines-logo-png_seeklogo-366077.png'
  },
  'TURKISH AIRLINES': {
    name: 'Turkish Airlines',
    code: 'TK',
    logo: 'https://images.seeklogo.com/logo-png/36/1/turkish-airlines-logo-png_seeklogo-366077.png'
  },
  'TK': {
    name: 'Turkish Airlines',
    code: 'TK',
    logo: 'https://images.seeklogo.com/logo-png/36/1/turkish-airlines-logo-png_seeklogo-366077.png'
  },

  // === ORIENTE MÉDIO ===
  'QATAR': {
    name: 'Qatar Airways',
    code: 'QR',
    logo: 'https://i.pinimg.com/1200x/ec/39/76/ec3976079d7ca4c545cc2d61c9f75f77.jpg'
  },
  'QR': {
    name: 'Qatar Airways',
    code: 'QR',
    logo: 'https://i.pinimg.com/1200x/ec/39/76/ec3976079d7ca4c545cc2d61c9f75f77.jpg'
  },
  'EMIRATES': {
    name: 'Emirates',
    code: 'EK',
    logo: 'https://i.pinimg.com/736x/31/fb/e5/31fbe5e73e1c6139715c29724d9ed6bc.jpg'
  },
  'EK': {
    name: 'Emirates',
    code: 'EK',
    logo: 'https://i.pinimg.com/736x/31/fb/e5/31fbe5e73e1c6139715c29724d9ed6bc.jpg'
  },
  'ETIHAD': {
    name: 'Etihad Airways',
    code: 'EY',
    logo: 'https://images.seeklogo.com/logo-png/17/1/etihad-airways-logo-png_seeklogo-177330.png'
  },
  'EY': {
    name: 'Etihad Airways',
    code: 'EY',
    logo: 'https://images.seeklogo.com/logo-png/17/1/etihad-airways-logo-png_seeklogo-177330.png'
  },

  // === AMÉRICA DO NORTE ===
  'AIR CANADA': {
    name: 'Air Canada',
    code: 'AC',
    logo: 'https://i.pinimg.com/1200x/be/51/98/be519886318af1d143cc7f54ef4a3c8d.jpg'
  },
  'AC': {
    name: 'Air Canada',
    code: 'AC',
    logo: 'https://i.pinimg.com/1200x/be/51/98/be519886318af1d143cc7f54ef4a3c8d.jpg'
  },
  'UNITED': {
    name: 'United Airlines',
    code: 'UA',
    logo: 'https://i.pinimg.com/736x/87/9f/af/879faf050ef8d50e034434429d70875b.jpg'
  },
  'UA': {
    name: 'United Airlines',
    code: 'UA',
    logo: 'https://i.pinimg.com/736x/87/9f/af/879faf050ef8d50e034434429d70875b.jpg'
  },
  'AMERICAN': {
    name: 'American Airlines',
    code: 'AA',
    logo: 'https://1000logos.net/wp-content/uploads/2016/10/American-Airlines-Logo.png'
  },
  'AMERICAN AIRLINES': {
    name: 'American Airlines',
    code: 'AA',
    logo: 'https://1000logos.net/wp-content/uploads/2016/10/American-Airlines-Logo.png'
  },
  'AA': {
    name: 'American Airlines',
    code: 'AA',
    logo: 'https://1000logos.net/wp-content/uploads/2016/10/American-Airlines-Logo.png'
  },
  'DELTA': {
    name: 'Delta Air Lines',
    code: 'DL',
    logo: 'https://i.pinimg.com/1200x/e5/26/9d/e5269d7324b68c2844818d8834444e55.jpg'
  },
  'DL': {
    name: 'Delta Air Lines',
    code: 'DL',
    logo: 'https://i.pinimg.com/1200x/e5/26/9d/e5269d7324b68c2844818d8834444e55.jpg'
  },
  'JETBLUE': {
    name: 'JetBlue Airways',
    code: 'B6',
    logo: 'https://s202.q4cdn.com/521076508/files/doc_downloads/logos/JetBlue-Logo.jpg'
  },
  'B6': {
    name: 'JetBlue Airways',
    code: 'B6',
    logo: 'https://s202.q4cdn.com/521076508/files/doc_downloads/logos/JetBlue-Logo.jpg'
  },
  'AEROMEXICO': {
    name: 'Aeroméxico',
    code: 'AM',
    logo: 'https://i.pinimg.com/736x/20/28/9e/20289e40062893352f91a5b28a76d5b2.jpg'
  },
  'AM': {
    name: 'Aeroméxico',
    code: 'AM',
    logo: 'https://i.pinimg.com/736x/20/28/9e/20289e40062893352f91a5b28a76d5b2.jpg'
  },

  // === AMÉRICA LATINA ===
  'COPA': {
    name: 'Copa Airlines',
    code: 'CM',
    logo: 'https://i.pinimg.com/1200x/1e/1d/29/1e1d2908d7dfcfade3737bf9cf6ce321.jpg'
  },
  'CM': {
    name: 'Copa Airlines',
    code: 'CM',
    logo: 'https://i.pinimg.com/1200x/1e/1d/29/1e1d2908d7dfcfade3737bf9cf6ce321.jpg'
  },
  'AVIANCA': {
    name: 'Avianca',
    code: 'AV',
    logo: 'https://www.logo.wine/a/logo/Avianca/Avianca-Logo.wine.svg'
  },
  'AV': {
    name: 'Avianca',
    code: 'AV',
    logo: 'https://www.logo.wine/a/logo/Avianca/Avianca-Logo.wine.svg'
  },
  'AEROLINEAS ARGENTINAS': {
    name: 'Aerolíneas Argentinas',
    code: 'AR',
    logo: 'https://images.seeklogo.com/logo-png/21/1/aerolineas-argentinas-logo-png_seeklogo-217527.png'
  },
  'AR': {
    name: 'Aerolíneas Argentinas',
    code: 'AR',
    logo: 'https://images.seeklogo.com/logo-png/21/1/aerolineas-argentinas-logo-png_seeklogo-217527.png'
  },
  'JETSMART': {
    name: 'JetSMART',
    code: 'JA',
    logo: 'https://logowik.com/content/uploads/images/jetsmart8250.logowik.com.webp'
  },
  'JA': {
    name: 'JetSMART',
    code: 'JA',
    logo: 'https://logowik.com/content/uploads/images/jetsmart8250.logowik.com.webp'
  },
  'SKY': {
    name: 'Sky Airline',
    code: 'H2',
    logo: 'https://logowik.com/content/uploads/images/sky-airline3521.logowik.com.webp'
  },
  'SKY AIRLINE': {
    name: 'Sky Airline',
    code: 'H2',
    logo: 'https://logowik.com/content/uploads/images/sky-airline3521.logowik.com.webp'
  },
  'H2': {
    name: 'Sky Airline',
    code: 'H2',
    logo: 'https://logowik.com/content/uploads/images/sky-airline3521.logowik.com.webp'
  },

  // === ÁFRICA ===
  'SOUTH AFRICAN': {
    name: 'South African Airways',
    code: 'SA',
    logo: 'https://thumbs.dreamstime.com/z/south-african-airways-logo-editorial-illustrative-white-background-logo-icon-vector-logos-icons-set-social-media-flat-banner-210443609.jpg'
  },
  'SA': {
    name: 'South African Airways',
    code: 'SA',
    logo: 'https://thumbs.dreamstime.com/z/south-african-airways-logo-editorial-illustrative-white-background-logo-icon-vector-logos-icons-set-social-media-flat-banner-210443609.jpg'
  },
  'TAAG': {
    name: 'TAAG Angola Airlines',
    code: 'DT',
    logo: 'https://upload.wikimedia.org/wikipedia/fr/3/3f/TAAG_-_Logo.png'
  },
  'DT': {
    name: 'TAAG Angola Airlines',
    code: 'DT',
    logo: 'https://upload.wikimedia.org/wikipedia/fr/3/3f/TAAG_-_Logo.png'
  }
};

/**
 * Busca dados da companhia aérea
 * @param {string} identifier - Nome ou código da companhia (ex: 'LATAM', 'LA', 'GOL', 'G3')
 * @returns {object|null} Dados da companhia ou null se não encontrada
 */
export function getAirline(identifier) {
  if (!identifier) return null;

  const key = identifier.toUpperCase().trim();
  return AIRLINES[key] || null;
}

/**
 * Busca apenas a URL do logo
 * @param {string} identifier - Nome ou código da companhia
 * @returns {string|null} URL do logo ou null
 */
export function getAirlineLogo(identifier) {
  const airline = getAirline(identifier);
  return airline?.logo || null;
}